<template>
	<div class="filter">
		<div class="filter-title">
			<h1>Ofertas</h1>
		</div>
		<div class="filter-inputs">
			<GenericMultiselect
				class="status-multiselect"
				:customClass="'mt-0'"
				ref="status"
				:options="statusOptions"
				:placeholder="'Status'"
				:fullWidth="!isWeb"
				:searchable="false"
				:needType="true"
				:type="'status'"
				:clearOnOpen="false"
				@changeInput="changeInput"
			/>
			<input
				class="filter-inputs__investors"
				type="text"
				placeholder="Busca"
				@input="searchInputDebounce"
				v-model="searchInput"
			/>
			<ButtonPrimary
				class="filter-inputs__btn"
				label="Adicionar Oferta"
				size="md"
				@click="addOffer"
			/>
		</div>
	</div>
</template>

<script>
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import ButtonPrimary from '@/components/shared/Button/ButtonPrimary/ButtonPrimary.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'TableFilter',
	components: { GenericMultiselect, ButtonPrimary },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		searchInput: null,
		debounce: null,
	}),
	created() {},
	mounted() {},
	methods: {
		addOffer() {
			this.$router.push({
				path: '/dashboard/offer/detail',
			});
		},
		searchInputDebounce() {
			clearTimeout(this.debounce);

			this.debounce = setTimeout(() => {
				this.$emit('searchFromInput', this.searchInput);
			}, 600);
		},
		changeInput(param) {
			let selectedStatus = !param.value ? null : param.value.name;
			this.$emit('searchFromInput', selectedStatus);
		},
	},
	computed: {
		...mapGetters('offerManagement', ['offerStatus']),
		statusOptions() {
			const options = this.offerStatus.offerStatus?.length
				? this.offerStatus.offerStatus?.map((option) => ({ id: option.id, name: option.name }))
				: [];

			return options;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'TableFilter.scss';
</style>
